import React from 'react';
import AssignAndSubmit from './AssignAndSubmit';
import ReviewAndReturn from './ReviewAndReturn';
import Complete from '../simple-action-center/Complete';

interface MobileTaskStepProps {
  handleClose: () => void;
  currentIndex: number;
  isRfi?: boolean;
  isWcpr?: boolean;
  documentTitle?: string;
}

export default function MobileTaskStep(props: MobileTaskStepProps) {
  const { handleClose, isRfi = false, isWcpr = false, documentTitle, currentIndex } = props;

  const getDialog = (num: number) => {
    if (num === 0 && !isRfi && !isWcpr) return <AssignAndSubmit handleClose={handleClose} />;
    if (num === 1)
      return (
        <ReviewAndReturn
          handleClose={handleClose}
          isRfi={isRfi}
          isWcpr={isWcpr}
          documentTitle={documentTitle}
        />
      );
    if (num === 2 && isRfi)
      return <Complete handleClose={handleClose} documentTitle={documentTitle} />;
    return undefined;
  };

  return <div>{getDialog(currentIndex)}</div>;
}
